var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12L22 25.5M22 32L22 29.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12L15 15.5M15 32L15 19.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 12L29 18.5M29 32L29 22.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 15.75,
    width: 6.5,
    height: 3.5,
    rx: 1.75,
    stroke: "#172664",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 25.75,
    width: 6.5,
    height: 3.5,
    rx: 1.75,
    stroke: "#172664",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 18.75,
    width: 6.5,
    height: 3.5,
    rx: 1.75,
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnConfiguration);
export default __webpack_public_path__ + "static/media/btn_configuration.284f4d4a7a11c880e54634fff2074cc2.svg";
export { ForwardRef as ReactComponent };